import React, { useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import { FaClipboardList, FaFilePdf, FaTimes } from 'react-icons/fa';
import './YoungApprenticeAttendance.css';

export default function YoungApprenticeAttendanceDialog({ loading, generating, days, periods, day, period, count, error, onClose, onRetry, onDayChange, onPeriodChange, onGenerate }) {
  const titleId = useId();
  const dialogRef = useRef(null);
  const closeRef = useRef(onClose);
  const generatingRef = useRef(generating);
  closeRef.current = onClose;
  generatingRef.current = generating;
  useEffect(() => {
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialogRef.current?.focus();
    const handleKey = (event) => {
      if (event.key === 'Escape' && !generatingRef.current) {
        event.preventDefault(); event.stopPropagation(); closeRef.current();
      }
      if (event.key !== 'Tab') return;
      const nodes = [...(dialogRef.current?.querySelectorAll('button:not(:disabled), select:not(:disabled)') || [])];
      const first = nodes[0]; const last = nodes[nodes.length - 1];
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialogRef.current)) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialogRef.current)) {
        event.preventDefault(); first.focus();
      }
    };
    document.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', handleKey);
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, []);
  return createPortal(<div className="ya-attendance-dialog__backdrop" onMouseDown={(event) => {
    if (event.target === event.currentTarget && !generating) onClose();
  }}>
    <section ref={dialogRef} className="ya-attendance-dialog ya-attendance-generator" role="dialog" aria-modal="true" aria-labelledby={titleId} tabIndex={-1}>
      <header className="ya-attendance-dialog__header"><h2 id={titleId}><FaClipboardList /> Lista de presença</h2><button type="button" aria-label="Fechar lista de presença" disabled={generating} onClick={onClose}><FaTimes /></button></header>
      <div className="ya-attendance-dialog__body">
        <p>Selecione o dia de curso e, se necessário, o período. A lista inclui somente aprendizes e vínculos ativos.</p>
        {loading && !generating && <p role="status">Carregando dias de curso e períodos...</p>}
        {!loading && !error && <p>{count} vínculo(s) ativo(s) disponível(is).</p>}
        <div className="ya-attendance-generator__filters">
          <label><span>Dia de curso</span><select value={day} disabled={loading} onChange={(event) => onDayChange(event.target.value)}><option value="">Selecione...</option>{days.map((value) => <option key={value} value={value}>{value}</option>)}</select></label>
          <label><span>Período</span><select value={period} disabled={loading || !day} onChange={(event) => onPeriodChange(event.target.value)}><option value="">Todos os períodos</option>{periods.map((value) => <option key={value} value={value}>{value}</option>)}</select></label>
        </div>
        {error && <div role="alert" className="ya-attendance-dialog__error">{error}<button type="button" disabled={loading} onClick={onRetry}>Tentar novamente</button></div>}
        {!loading && !error && !days.length && <p>Nenhum dia de curso disponível para aprendizes e vínculos ativos.</p>}
      </div>
      <footer className="ya-attendance-dialog__footer"><button type="button" className="young-apprentice-button young-apprentice-button--secondary" disabled={generating} onClick={onClose}>Cancelar</button><button type="button" className="young-apprentice-button young-apprentice-button--primary" disabled={loading || !day || Boolean(error)} onClick={onGenerate}><FaFilePdf /> {generating ? 'Gerando...' : 'Gerar lista em PDF'}</button></footer>
    </section>
  </div>, document.body);
}
